import React from 'react'
import { DatePicker } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker
type DateStringPickerProps = Omit<React.ComponentProps<typeof RangePicker>, 'value' | 'onChange'> & {
  value?: (string | undefined)[] | null
  onChange?: (val?: (string | undefined)[] | null) => void
}

type AntdFormDateStringPickerProps = React.ComponentProps<typeof RangePicker> & {
  //
} & AntdFormItemProps

const underlyingValueFormat = 'YYYY-MM-DD'

export const DateRangeStringPicker: React.FC<DateStringPickerProps> = ({
  value,
  onChange,
  ...props
}) => {
  const format = props.format as string || underlyingValueFormat

  const handleChange = (value?: (string | undefined)[]) => {
    onChange?.(value ? value : undefined)
  }

  return (
    <RangePicker
      {...props}
      value={value ? [value[0] ? dayjs(value[0], format) : undefined, value[1] ? dayjs(
        value[1],
        format,
      ) : undefined] : undefined}
      onChange={(dayjsObj) => {
        if (dayjsObj) {
          const finalValue = [dayjsObj[0] ? dayjsObj[0].format(format) : undefined, dayjsObj[1] ? dayjsObj[1].format(
            format) : undefined]
          handleChange(finalValue)
        } else {
          handleChange(undefined)
        }
      }}
      format={format}
    />
  )
}

export const AntdFormDateRangePicker: React.FC<AntdFormDateStringPickerProps> = ({
  fieldProps,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  value,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <DateRangeStringPicker {...props} className={cn('w-full', className)} />
    </AntdFormItem>
  )
}


